import { Epic } from 'redux-observable';
import { from } from 'rxjs';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { InboxViewServiceImpl } from '../services';
import {
  inboxViewFetchDashboardFailed,
  inboxViewFetchDashboardRequest,
  inboxViewFetchDashboardSuccess,
} from '../inboxViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof inboxViewFetchDashboardRequest>;
type OUT =
  | ReturnType<typeof inboxViewFetchDashboardSuccess>
  | ReturnType<typeof inboxViewFetchDashboardFailed>;

export const InboxViewOnFetchDataEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(inboxViewFetchDashboardRequest.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return from(
        InboxViewServiceImpl.getInboxData()
          .then((data) => inboxViewFetchDashboardSuccess(data))
          .catch((error) => {
            console.error(error);
            return inboxViewFetchDashboardFailed({
              msg: 'Failed to fetch data',
            });
          }),
      );
    }),
  );
